'use client'

import { useTranslation } from '../../hooks/useTranslation';
export default function WhyChooseUs() {
  const { t } = useTranslation();
  const items = t('why.items', { returnObjects: true });

const features = items.map((item, index) => ({
  id: index + 1,
  title: item.title,
  description: item.desc
}));

  return (
    <section
      className="relative py-12 sm:py-16 md:py-20 min-h-screen bg-no-repeat bg-center bg-cover sm:bg-[length:110%] transition-all duration-300"
      style={{
        backgroundImage: "url('/images/why.png')"
      }}
    >

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 md:px-8 h-full">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-16 md:mb-20 lg:mb-[100px]">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold text-white mb-3 sm:mb-4">
            {t('why.title')}
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto text-sm sm:text-base px-4 sm:px-0">
            {t('why.desc')}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-6 sm:gap-8 md:gap-10 max-w-none sm:max-w-3xl xl:max-w-3xl mx-auto">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="bg-[#4b4b4b7d] bg-opacity-56 backdrop-blur-sm rounded-xl p-4 sm:p-5 md:p-6 hover:bg-opacity-90 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-lg"
            >
              <h3 className="text-base sm:text-lg font-medium text-white mb-2 sm:mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-300 font-normal text-xs sm:text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}